import { render, staticRenderFns } from "./AddProduction.vue?vue&type=template&id=40d0bf47&scoped=true"
import script from "./AddProduction.vue?vue&type=script&lang=js"
export * from "./AddProduction.vue?vue&type=script&lang=js"
import style0 from "./AddProduction.vue?vue&type=style&index=0&id=40d0bf47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d0bf47",
  null
  
)

export default component.exports